export class ControlStateConstants {
    public static CONTROL_STATE_STORAGE_PREFIX = 'ControlState_';
    public static CONTROL_STATE_SIDEBAR_TOGGLE = ControlStateConstants.CONTROL_STATE_STORAGE_PREFIX + 'SideBarToggle';
    public static CONTROL_STATE_SIDEBAR_TOGGLE_XS_SM = ControlStateConstants.CONTROL_STATE_STORAGE_PREFIX + 'SideBarToggleXsSm';
}
